import React from 'react';

import { IBadgeFields } from '../../../types/contentful';
import ImageLink from '../ImageLink';

import RichText from '../RichText';

import { Asset } from '../AtomicComponents/Asset';

export function Badge({
  badgeHeader,
  badgeImage,
  imageLink,
  badgeCopy
}: IBadgeFields) {
  return (
    <div className="border-box flex min-w-80 max-w-3xl flex-row items-center justify-between gap-5 tablet:min-w-36 tablet:max-w-52 tablet:flex-col tablet:justify-start">
      <div className="min-w-28">
        {imageLink ? (
          <ImageLink
            {...{
              ...imageLink.fields,
              linkProps: {
                className: ''
              }
            }}
          >
            {(image) => {
              return (
                <Asset
                  asset={image}
                  className="h-[108px] w-[108px] rounded-lg object-cover"
                />
              );
            }}
          </ImageLink>
        ) : (
          badgeImage && (
            <Asset
              asset={badgeImage}
              className="h-[108px] w-[108px] rounded-lg object-cover"
            />
          )
        )}
      </div>
      <div>
        <h3 className="heading-3 mb-2 font-medium leading-6 tablet:!text-xl tablet:leading-8">
          {badgeHeader}
        </h3>
        {badgeCopy && (
          <div className="[&>p]:text-base [&>p]:leading-6">
            <RichText data={badgeCopy} />
          </div>
        )}
      </div>
    </div>
  );
}
